import toastStore from "@src/store/toast";

const message = {
  error(message){
    toastStore.sendMessage(message);
  },
  success(message){
    toastStore.sendMessage(message);
  }
}

export default message;
